import React, { useState } from 'react';
import { ArrowLeft, ShoppingCart, Heart, Star, Plus, Minus } from 'lucide-react';
import { Link } from 'react-router-dom';

const EcommerceStore = () => {
  const [cartCount, setCartCount] = useState(3);
  const [quantity, setQuantity] = useState(1);

  const products = [
    {
      id: 1,
      name: 'Wireless Headphones',
      price: 129.99,
      rating: 4.5,
      image: '🎧',
      inStock: true,
    },
    {
      id: 2,
      name: 'Smart Watch Pro',
      price: 299.99,
      rating: 4.8,
      image: '⌚',
      inStock: true,
    },
    {
      id: 3,
      name: 'Laptop Stand',
      price: 49.99,
      rating: 4.2,
      image: '💻',
      inStock: true,
    },
    {
      id: 4,
      name: 'Mechanical Keyboard',
      price: 159.99,
      rating: 4.7,
      image: '⌨️',
      inStock: false,
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 pt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Link
          to="/portfolio"
          className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 mb-8"
        >
          <ArrowLeft size={20} />
          Back to Portfolio
        </Link>

        {/* Header */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-8 flex items-center justify-between">
          <div>
            <h1 className="text-4xl font-bold text-gray-900 mb-2">E-commerce Store</h1>
            <p className="text-gray-600">Modern shopping experience with seamless checkout</p>
          </div>
          <div className="relative">
            <button className="bg-primary-600 text-white p-3 rounded-lg hover:bg-primary-700 transition-colors">
              <ShoppingCart size={24} />
            </button>
            {cartCount > 0 && (
              <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center">
                {cartCount}
              </span>
            )}
          </div>
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {products.map((product) => (
            <div key={product.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-48 bg-gradient-to-br from-primary-100 to-primary-200 flex items-center justify-center text-6xl">
                {product.image}
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-1">
                    <Star className="text-yellow-400 fill-current" size={16} />
                    <span className="text-sm text-gray-600">{product.rating}</span>
                  </div>
                  <button className="text-gray-400 hover:text-red-500">
                    <Heart size={20} />
                  </button>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">{product.name}</h3>
                <div className="flex items-center justify-between">
                  <span className="text-2xl font-bold text-gray-900">${product.price}</span>
                  <button
                    disabled={!product.inStock}
                    className={`px-4 py-2 rounded-lg font-semibold transition-colors ${
                      product.inStock
                        ? 'bg-primary-600 text-white hover:bg-primary-700'
                        : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    }`}
                  >
                    {product.inStock ? 'Add to Cart' : 'Out of Stock'}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Product Detail Section */}
        <div className="bg-white rounded-lg shadow-md p-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="h-96 bg-gradient-to-br from-primary-100 to-primary-200 rounded-lg flex items-center justify-center text-9xl">
              🎧
            </div>
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Wireless Headphones</h2>
              <div className="flex items-center gap-2 mb-4">
                <div className="flex items-center">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      className={`${i < 4 ? 'text-yellow-400 fill-current' : 'text-gray-300'}`}
                      size={20}
                    />
                  ))}
                </div>
                <span className="text-gray-600">(127 reviews)</span>
              </div>
              <p className="text-3xl font-bold text-gray-900 mb-6">$129.99</p>
              <p className="text-gray-600 mb-6">
                Premium wireless headphones with noise cancellation, 30-hour battery life,
                and crystal-clear sound quality.
              </p>
              <div className="flex items-center gap-4 mb-6">
                <span className="text-gray-700 font-medium">Quantity:</span>
                <div className="flex items-center gap-3 border rounded-lg">
                  <button
                    onClick={() => setQuantity(Math.max(1, quantity - 1))}
                    className="p-2 hover:bg-gray-100"
                  >
                    <Minus size={20} />
                  </button>
                  <span className="px-4 py-2 font-semibold">{quantity}</span>
                  <button
                    onClick={() => setQuantity(quantity + 1)}
                    className="p-2 hover:bg-gray-100"
                  >
                    <Plus size={20} />
                  </button>
                </div>
              </div>
              <div className="flex gap-4">
                <button className="flex-1 bg-primary-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-primary-700 transition-colors">
                  Add to Cart
                </button>
                <button className="flex-1 bg-gray-900 text-white py-3 px-6 rounded-lg font-semibold hover:bg-gray-800 transition-colors">
                  Buy Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EcommerceStore;

